import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzBadgeComponent } from 'ng-zorro-antd/badge';
import { IconComponent } from '../../icon/icon.component';

@Component({
  selector: 'dpqa-bad-state',
  standalone: true,
  imports: [CommonModule, NzBadgeComponent, IconComponent],
  templateUrl: './bad-state.component.html',
  styleUrl: './states.component.less',
})
export class BadStateComponent {
}
